import request from '@/utils/request'

export function add(data) {
  return request({
    url: 'dict',
    method: 'post',
    data
  })
}

export function del(id) {
  return request({
    url: 'dict/' + id,
    method: 'delete'
  })
}

export function edit(data) {
  return request({
    url: 'dict',
    method: 'put',
    data
  })
}
